module.exports = __webpack_public_path__ + "img/login.500256e9.png";